export const LOGIN_REGISTRATION: string = 'Log in / Register';
export const LOG_OUT: string = 'Log out';
export const ACCOUNT_URL: string = '/Account/LoginRedirect.aspx';
export const LOG_OUT_URL: string = '/LogoutCDE.ashx';
export const NAVIGATION_COMPONENT_SELECTOR: string = '#navigation-component';
